import { NameBadge } from "components/TreatmentPlan"
import { User, Monitor, UserCheck } from "lucide-react"

const OverView = ({ treatmentPlan }) => {
  let { title, amount_to_pay, provider, submitted_by, presented_by } = treatmentPlan || {}
  let { first_name: providerFirstName, last_name: providerLastName } = provider?.data?.attributes || {}
  let { first_name: submittedByFirstName, last_name: submittedByLastName } = submitted_by?.data?.attributes || {}
  let { first_name: presentedByFirstName, last_name: presentedByLastName } = presented_by?.data?.attributes || {}

  return (
    <div className="card w-full bg-white border border-base-200 shadow-sm rounded-2xl overflow-hidden hover:shadow-md transition-all duration-300">
      <div className="card-body p-5 flex flex-col gap-2">
        <div className="flex flex-row items-center justify-between gap-4">
          <div className="max-w-3xl">
            <h1 className="text-sm font-semibold text-secondary-900 leading-snug">{title}</h1>
          </div>

          <div className="text-right shrink-0">
            <span className="text-md font-bold text-blue-500 tracking-tight">
              ${amount_to_pay.toLocaleString('en-US', { minimumFractionDigits: 2 })}
            </span>
          </div>
        </div>

        <div className="flex flex-row flex-wrap items-center gap-3">
          <NameBadge
            name={`${providerFirstName} ${providerLastName}`}
            icon={<User size={13} />}
            iconBgClassName="bg-blue-100 text-blue-600"
          />

          <NameBadge
            name={`${submittedByFirstName} ${submittedByLastName}`}
            icon={<Monitor size={13} />}
            iconBgClassName="bg-blue-100 text-blue-600"
          />

          <NameBadge
            name={`${presentedByFirstName} ${presentedByLastName}`}
            icon={<UserCheck size={13} />}
            iconBgClassName="bg-success-100 text-success-600"
          />
        </div>
      </div>
    </div>
  )
}

export default OverView
